export class FpsCounter {
    constructor() {
        this.frames = 0;
        this.lastTime = performance.now();
        this.fps = 0;
        this.element = null;
        this.visible = false;
    }

    init() {
        // Create FPS counter element
        const fpsCounter = document.createElement('div');
        fpsCounter.id = 'fps-counter';
        fpsCounter.style.position = 'fixed';
        fpsCounter.style.top = '10px';
        fpsCounter.style.right = '10px';
        fpsCounter.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        fpsCounter.style.color = '#fff';
        fpsCounter.style.padding = '5px 10px';
        fpsCounter.style.borderRadius = '4px';
        fpsCounter.style.fontFamily = 'monospace';
        fpsCounter.style.fontSize = '16px';
        fpsCounter.style.zIndex = '1000';
        fpsCounter.style.display = this.visible ? 'block' : 'none';
        fpsCounter.textContent = 'FPS: 0';
        
        document.body.appendChild(fpsCounter);
        this.element = fpsCounter;
    }

    update() {
        if (!this.element) return;
        
        this.frames++;
        const currentTime = performance.now();
        const elapsed = currentTime - this.lastTime;
        
        // Update FPS calculation every 500ms
        if (elapsed >= 500) {
            this.fps = Math.round((this.frames * 1000) / elapsed);
            this.lastTime = currentTime;
            this.frames = 0;
            this.element.textContent = `FPS: ${this.fps}`;
        }
    }

    setVisibility(visible) {
        this.visible = visible;
        if (this.element) {
            this.element.style.display = visible ? 'block' : 'none';
        }
    }
}
